import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import authProvider from '../../../../../core/AuthenticationProvider'
import { TransferInformationPopup } from '../../../../cartAndOrders/common/poup/TransferInformationPopup'
import {
  getBankTransferInfo,
  getUserPricingPackages,
} from '../../../../cartAndOrders/store/thunk'
import { SizeTracker } from '../../../../common/SizeTracker'
import { selectUserProfile } from '../../../../common/category/store/slice'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Popup } from '../../../../common/popup'
import { ScrollComponent } from '../../../../common/scrollComponent'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import classes from '../../../index.module.scss'
import { ORDER_TYPE } from '../../common/constants'
import { postNewTransactionOrders } from '../../orderManagement/store/thunk'
import {
  resetDataPreview,
  selectSNPNewTransactionPreview,
} from '../../packageSubManagement/store/slice'
import { selectCheckRules, selectInvoiceReceivingForm } from '../../store/slice'
import { postSubscriptionAndPackageNewTransaction } from '../../store/thunk'
import { BuyPackageBox } from '../BuyPackageBox'
import { PayNowButton } from '../PayNowButton'
import { PriceConfirmationBox } from '../PriceConfirmationBox'
import { TermsAndConditionPayment } from '../TermsAndConditionPayment'
import { UpgradeAccountBox } from '../UpgradeAccountBox'
import {
  checkAllValidFields,
  checkEmailValid,
  checkPhoneValid,
  getOrderType,
} from '../helper'
import { InvoiceReceivingInfo } from '../popupBuyNow/InvoiceReceivingInfo'
import { PaymentMethod } from '../popupBuyNow/PaymentMethod'
import { BANK_TRANSFER_TYPE, TYPE_TRANSFER } from '../popupBuyNow/constants'
import { IS_VALID_FIELDS } from '../popupContract/constants'
import { PAYMENT_METHOD, PAYMENT_METHOD_NOT_INCLUDE_PACKAGE } from './constants'

export const PopupPaymentInformation = ({
  isShow,
  setIsShow,
  orderId,
  orderType,
  isScreening,
  oldPrice,
  exchangeRateAPI,
  discountedAmount,
  discountValue,
  vatPrice,
  grandTotalPrice,
}) => {
  const dispatch = useDispatch()
  const { height } = useViewport()

  const invoiceReceivingForm = useSelector(selectInvoiceReceivingForm)
  const isCheckedTermsAndCondition = useSelector(selectCheckRules)
  const userProfile = useSelector(selectUserProfile)
  const dataPreview = useSelector(selectSNPNewTransactionPreview)

  const [isShowTransferInfo, setIsShowTransferInfo] = useState(false)
  const [isValidInvoiceForm, setIsValidInvoiceForm] = useState(IS_VALID_FIELDS)
  const [isVisibility, setVisibility] = useState(false)
  const [isDisablePackage, setDisablePackage] = useState(false)
  const [isShowInvalidPackage, setShowInvalidPackage] = useState(false)
  const [loadingPayment, setLoadingPayment] = useState(false)

  const [paymentMethod, setPaymentMethod] = useState(
    Object.values(PAYMENT_METHOD)[1],
  )
  const [currencyType, setCurrencyType] = useState(
    Object.values(TYPE_TRANSFER)[0],
  )
  const [bankTransferType, setBankTransferType] = useState(
    Object.values(BANK_TRANSFER_TYPE)[0],
  )

  const handleClose = () => {
    setIsShow(false)
    dispatch(resetDataPreview())
  }

  const sendRequest = () => {
    if (paymentMethod !== PAYMENT_METHOD.PACKAGE) {
      setIsValidInvoiceForm({
        phone: checkPhoneValid(invoiceReceivingForm.phone),
        invoiceReceivingEmail: checkEmailValid(
          invoiceReceivingForm.invoiceReceivingEmail,
        ),
        customerName: Boolean(invoiceReceivingForm.customerName),
        companyName: Boolean(invoiceReceivingForm.companyName),
        companyAddress: Boolean(invoiceReceivingForm.companyAddress),
        taxCode: Boolean(invoiceReceivingForm.taxCode),
      })

      if (
        !checkPhoneValid(invoiceReceivingForm.phone) ||
        !checkEmailValid(invoiceReceivingForm.invoiceReceivingEmail) ||
        !Boolean(invoiceReceivingForm.customerName) ||
        !Boolean(invoiceReceivingForm.companyName) ||
        !Boolean(invoiceReceivingForm.companyAddress) ||
        !Boolean(invoiceReceivingForm.taxCode)
      ) {
        return
      }
    }

    if (paymentMethod === PAYMENT_METHOD.PACKAGE) {
      if (isDisablePackage) {
        setShowInvalidPackage(true)
        return
      }
    }

    const params =
      paymentMethod === PAYMENT_METHOD.BANK_TRANSFERS
        ? {
            data: {
              snpOrderId: orderId,
              paymentMethod: paymentMethod,
              paymentCurrency: currencyType,
              ...invoiceReceivingForm,
            },
          }
        : {
            data: {
              snpOrderId: orderId,
              paymentMethod: paymentMethod,
              ...invoiceReceivingForm,
            },
          }

    const orderParams =
      paymentMethod === PAYMENT_METHOD.BANK_TRANSFERS
        ? {
            data: {
              orderId: orderId,
              paymentMethod: paymentMethod,
              paymentCurrency: currencyType,
              ...invoiceReceivingForm,
            },
          }
        : paymentMethod === PAYMENT_METHOD.PACKAGE
        ? {
            data: {
              orderId: orderId,
              paymentMethod: paymentMethod,
            },
          }
        : {
            data: {
              orderId: orderId,
              paymentMethod: paymentMethod,
              ...invoiceReceivingForm,
            },
          }

    const allowSendRequest =
      paymentMethod === PAYMENT_METHOD.PACKAGE
        ? true
        : checkAllValidFields(isValidInvoiceForm)

    const postNewTransaction = () => {
      return orderType === ORDER_TYPE.REPORT
        ? dispatch(postNewTransactionOrders(orderParams))
        : dispatch(postSubscriptionAndPackageNewTransaction(params))
    }

    if (allowSendRequest) {
      setLoadingPayment(true)
      postNewTransaction()
        .unwrap()
        .then((res) => {
          const transactionCode = res?.data || null
          if (paymentMethod === PAYMENT_METHOD.BANK_TRANSFERS) {
            dispatch(
              getBankTransferInfo({
                TransactionCode: transactionCode,
                CurrencyCode: currencyType,
              }),
            )
              .unwrap()
              .then(() => {
                setIsShowTransferInfo(true)
                setVisibility(true)
                setLoadingPayment(false)
              })
              .catch(() => {})
          }

          if (paymentMethod === PAYMENT_METHOD.PACKAGE) {
            if (res?.success) {
              EventEmitter.dispatch(
                SHOW_POPUP_CONFIRMATION,
                'userManagement.paymentMethod.CONFIRM_SUCCESS_PACKAGE',
              )
            } else {
              EventEmitter.dispatch(
                SHOW_POPUP_CONFIRMATION,
                'userManagement.paymentMethod.CONFIRM_FAIL_PACKAGE',
              )
            }
            setIsShow(false)
          }

          if (paymentMethod === PAYMENT_METHOD.CARD) {
            authProvider.getUser().then((user) => {
              const navigateLink = [
                process.env.REACT_APP_SERVICE_ENDPOINT,
                '/Transaction/PaymentCardRedirect',
                `?PaymentGate=${bankTransferType}`,
                `&TransactionCode=${transactionCode}`,
                `&access_token=${user.access_token}`,
              ].join('')
              window.open(navigateLink, '_self')
            })
            return
          }
          return
        })
        .catch(() => {
          setLoadingPayment(false)
        })
    }
  }

  useEffect(() => {
    if (orderType === ORDER_TYPE.REPORT) {
      dispatch(
        getUserPricingPackages({
          GroupByReportType: true,
        }),
      )
    }
  }, [])

  return (
    <Fragment>
      {isShow && (
        <Popup
          zIndexPopup={99}
          appendStyleContent={{
            padding: 20,
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
            height: 0.95 * height,
            width: 600,
            display: isVisibility ? 'none' : 'block',
          }}
        >
          <SizeTracker
            renderTopComponent={() => <TitlePopup handleClose={handleClose} />}
            renderBottomComponent={() => (
              <div className="dFlex justifyContentEnd pt1">
                <PayNowButton
                  onClick={sendRequest}
                  title="userManagement.paymentInformation.PAY_NOW"
                  disabled={
                    paymentMethod === PAYMENT_METHOD.PACKAGE
                      ? false
                      : !isCheckedTermsAndCondition ||
                        !Object.values(isValidInvoiceForm).every(Boolean)
                  }
                  loading={loadingPayment}
                />
              </div>
            )}
          >
            {(size) => {
              return (
                <div
                  className={[classes.popupBuyPackage].join(' ')}
                  style={{ height: `calc(100% - ${size.height}px)` }}
                >
                  <ScrollComponent
                    disableScroll={paymentMethod === PAYMENT_METHOD.PACKAGE}
                  >
                    {orderType === ORDER_TYPE.REPORT ? (
                      <PaymentMethod
                        paymentMethodList={PAYMENT_METHOD}
                        paymentMethod={paymentMethod}
                        setPaymentMethod={setPaymentMethod}
                        currencyType={currencyType}
                        setCurrencyType={setCurrencyType}
                        bankTransferType={bankTransferType}
                        setBankTransferType={setBankTransferType}
                        isScreening={isScreening}
                        orderId={orderId}
                        setDisablePackage={setDisablePackage}
                        isShowInvalidPackage={isShowInvalidPackage}
                      />
                    ) : (
                      <PaymentMethod
                        paymentMethodList={PAYMENT_METHOD_NOT_INCLUDE_PACKAGE}
                        paymentMethod={paymentMethod}
                        setPaymentMethod={setPaymentMethod}
                        currencyType={currencyType}
                        setCurrencyType={setCurrencyType}
                        bankTransferType={bankTransferType}
                        setBankTransferType={setBankTransferType}
                      />
                    )}

                    {getOrderType(dataPreview) === ORDER_TYPE.BOTH_SNP && (
                      <Fragment>
                        <UpgradeAccountBox
                          oldPrice={dataPreview?.subscription.amount}
                          price={dataPreview?.subscription.discountedAmount}
                          exchangeRateAPI={dataPreview?.exchangeRate}
                        />
                        <BuyPackageBox
                          oldPrice={dataPreview?.package.amount}
                          discountValue={dataPreview?.package.discountValue}
                          totalPrice={dataPreview?.package.discountedAmount}
                          exchangeRateAPI={dataPreview?.exchangeRate}
                        />
                      </Fragment>
                    )}

                    {[
                      PAYMENT_METHOD.BANK_TRANSFERS,
                      PAYMENT_METHOD.CARD,
                    ].includes(paymentMethod) &&
                      (orderType === ORDER_TYPE.REPORT ||
                      !Object.keys(dataPreview).length ? (
                        <PriceConfirmationBox
                          exchangeRateAPI={exchangeRateAPI}
                          oldPrice={oldPrice}
                          vatPrice={vatPrice}
                          discountedAmount={discountedAmount}
                          discountValue={discountValue}
                          grandTotalPrice={grandTotalPrice}
                          orderType={orderType}
                        />
                      ) : getOrderType(dataPreview) === ORDER_TYPE.BOTH_SNP ? (
                        <PriceConfirmationBox
                          exchangeRateAPI={dataPreview?.exchangeRate}
                          vatPrice={dataPreview?.vat}
                          discountedAmount={dataPreview?.amount}
                          grandTotalPrice={dataPreview?.totalAmount}
                          orderType={getOrderType(dataPreview)}
                        />
                      ) : getOrderType(dataPreview) === ORDER_TYPE.PACKAGE ? (
                        <PriceConfirmationBox
                          exchangeRateAPI={dataPreview?.exchangeRate}
                          oldPrice={dataPreview?.package?.amount}
                          vatPrice={dataPreview?.package?.vat}
                          discountValue={dataPreview?.package?.discountValue}
                          grandTotalPrice={dataPreview?.totalAmount}
                          orderType={getOrderType(dataPreview)}
                        />
                      ) : (
                        <PriceConfirmationBox
                          exchangeRateAPI={dataPreview?.exchangeRate}
                          oldPrice={dataPreview?.subscription?.amount}
                          vatPrice={dataPreview?.vat}
                          discountedAmount={
                            dataPreview?.subscription?.discountedAmount
                          }
                          grandTotalPrice={dataPreview?.totalAmount}
                          orderType={getOrderType(dataPreview)}
                        />
                      ))}

                    {paymentMethod !== Object.values(PAYMENT_METHOD)[0] && (
                      <InvoiceReceivingInfo
                        isValid={isValidInvoiceForm}
                        setIsValid={setIsValidInvoiceForm}
                        userProfile={userProfile}
                      />
                    )}

                    {[
                      PAYMENT_METHOD.BANK_TRANSFERS,
                      PAYMENT_METHOD.CARD,
                    ].includes(paymentMethod) && <TermsAndConditionPayment />}
                  </ScrollComponent>
                </div>
              )
            }}
          </SizeTracker>
        </Popup>
      )}
      <TransferInformationPopup
        isShow={isShowTransferInfo}
        type={currencyType}
        orderId={orderId}
        orderType={orderType}
        onClose={setIsShow}
      />
    </Fragment>
  )
}

const TitlePopup = ({ handleClose }) => {
  return (
    <Element
      className={[
        'dFlex justifyContentBetween alignItemsCenter',
        classes.header,
      ].join(' ')}
      style={{
        borderBottom: '1px solid #e5e5e8',
      }}
    >
      <Element
        elementName="span"
        style={{
          fontSize: 20,
          fontWeight: 500,
          lineHeight: '24px',
          color: '#0553A5',
          width: `calc(100% - 30px)`,
        }}
      >
        <Translate value="userManagement.paymentInformation.TITLE" />
      </Element>
      <Element onClick={handleClose}>
        <Icon
          className="icon-delete"
          style={{ fontSize: 12, color: '#9C9C9C' }}
        />
      </Element>
    </Element>
  )
}
